import { CurrentAccountTaxpayerStatsCard } from '@/app/modules/current-account/components/CurrentAccountTaxpayerStatsCard';
import { TaxReturnCard } from '@/app/modules/tax-returns/components/TaxReturnCard';

interface PaymentReferenceProps {
  id: string;
}

export function PaymentReference({ id }: PaymentReferenceProps) {
  return (
    <>
      <TaxReturnCard id={id} />
      <CurrentAccountTaxpayerStatsCard col={12} />
    </>
  );
}
